const ContentCard = (function ContentCard() {
	const clickableEls = document.querySelectorAll('.clickable');

	function attachEvents() {
		clickableEls && clickableEls.forEach(clickable => {
			clickable.addEventListener('click', () => {
				const anchor = clickable.querySelector('a');
				if (anchor) {
					anchor.click();
				}
			});
		});
	}
	function init() {
		attachEvents();
	}
	return {
		init: init
	};
}());

window.addEventListener('load', function() {
	ContentCard.init();
});